document.documentElement.classList.replace('no-js', 'js');
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.rb-mobile-menu[open], .rb-privacy[open]').forEach((detail) => { detail.open = false; detail.querySelector('summary').focus(); });
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('.rb-mobile-menu a');
  if (link) link.closest('details').open = false;
  document.querySelectorAll('.rb-privacy[open], .rb-mobile-menu[open]').forEach((detail) => { if (!detail.contains(event.target)) detail.open = false; });
});
